import { render, staticRenderFns } from "./AttributeTable.vue?vue&type=template&id=14ca6c80"
import script from "./AttributeTable.vue?vue&type=script&lang=js"
export * from "./AttributeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports